import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sort'
})
export class SortPipe implements PipeTransform {

  /// Use in ngFor="let obj of objects | orderBy : ObjFieldName : OrderByType"
  /// orderType == True => Decending
  /// orderType == False => Ascending
  transform(array: Array<any>, orderField: string, OT: number):  Array<string> {
    let orderType: boolean = (OT == 1 ? true : false);
    array.sort(( a: any, b: any ) => {
        let ae = a[orderField];
        let be = b[orderField];
        if (ae == undefined && be == undefined) return 0;
        if (ae == undefined && be != undefined) return orderType ? 1 : -1;
        if (ae != undefined && be == undefined) return orderType ? -1 : 1;
        if (ae == be) return 0;
        return orderType ? (ae.toString().toLowerCase() > be.toString().toLowerCase() ? -1 : 1) : (be.toString().toLowerCase() > ae.toString().toLowerCase() ? -1 : 1);
    });
    return array;
  }
}
